export default function accountReducer(account, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "partner":
      return { ...account, [action.type]: action.value !== "" ? { ...action.value, pbxes: [] } : {} };
    case "pbxes":
      return { ...account, [action.type]: [action.value] };
    case "resetPassword":
      return { ...account, password: action.value, confirmPassword: action.value };

    case "addPbx": {
      if (account?.partner?.id) {
        return { ...account, partner: { ...account.partner, pbxes: [...account.partner.pbxes, action.value] } };
      }

      return { ...account, pbxes: [...account.pbxes, action.value] };
    }
    case "removePbx": {
      if (account?.partner?.id) {
        return {
          ...account,
          partner: { ...account.partner, pbxes: account.partner.pbxes.filter((_pbx) => _pbx.id !== action.value.id) },
        };
      }

      return { ...account, pbxes: account.pbxes.filter((_pbx) => _pbx.id !== action.value.id) };
    }

    default:
      return { ...account, [action.type]: action.value };
  }
}
